export function getCurrentSlide(){
	return this.elements.slides[this.currentSlide + this.slideOffset];
}

export function next(){
	this.changeSlide(1, true);
}

export function previous(){
	this.changeSlide(-1, true);
}



// WEBPACK FOOTER //
// ./node_modules/ui-slider/app/js/src/slider/util.js